module.exports = __webpack_public_path__ + "static/media/axpo-logo-transparent.82a0d393.png";